import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollVertical } from 'elements/functional/ScrollVertical';
import { motion } from 'framer-motion';
import { EColors, EColors2, EFonts, EGrads, EHovers } from 'libs/styles/styling';
import styled from 'styled-components/macro';

export interface EmbedState {
    windowHeight: 0;
    windowWidth: 0;
    iframeOffset: 0;
}

interface Props {
    content: JSX.Element;
    title: string;
    embedState: EmbedState;
    onClose: React.MouseEventHandler<HTMLElement>;
    className?: string;
}

const OFFSET_TOP = 150;

export const ModalWrapperEmbedded = (props: Props): JSX.Element => {
    const animation = {
        initial: { transform: 'scale(0)' },
        animate: { transform: 'scale(1)' },
        transition: {
            delay: 0.1,
            transform: { duration: 0.3 },
            default: { ease: 'linear' }
        }
    };

    const offset = props.embedState.iframeOffset + OFFSET_TOP;

    return (
        <S_Overlay onClick={props.onClose} className={props.className}>
            <S_Animation $offset={offset} {...animation}>
                <S_ClosePcWrapper onClick={props.onClose}>
                    <S_CloseButton icon={['fal', 'xmark']} />
                </S_ClosePcWrapper>
                <S_ModalMiniContent light={true}>
                    {props.title && <S_Title>{props.title}</S_Title>}
                    <S_Content
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        {props.content}
                    </S_Content>
                </S_ModalMiniContent>
            </S_Animation>
        </S_Overlay>
    );
};

const S_Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px;
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const S_Animation = styled(motion.div)<{ $offset: number }>`
    width: 100%;
    max-width: 450px;
    height: 550px;
    max-height: 90%;
    position: absolute;
    margin-bottom: 400px;
    top: ${(props) => props.$offset}px;
`;

const S_ModalMiniContent = styled(ScrollVertical)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    border-radius: 7px;
    box-shadow: 5px 5px 15px rgb(0 0 0 / 20%);
    background-color: #f6f9ff;
`;

const S_Content = styled.div`
    position: relative;
`;

const S_Title = styled.div`
    padding: 20px 0px 10px 35px;
    width: 100%;
    font-family: ${EFonts.Bold};
    font-size: 18px;
    line-height: 25px;
    line-height: normal;
    color: ${EColors2.DARK};
    background: #fff;
`;

const S_CloseWrapper = styled(motion.div)`
    top: 10px;
    right: 10px;
    position: fixed;
    z-index: 2000001;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: ${EColors.DARK};
    background: ${EGrads.ACC1_GRAD};
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        box-shadow: ${EHovers.LIGHT2}, 0px 10px 30px rgba(0, 0, 0, 0.3);
    }
`;

const S_ClosePcWrapper = styled(S_CloseWrapper)`
    position: absolute;
    right: 0px;
    top: -55px;
`;

const S_CloseButton = styled(FontAwesomeIcon)`
    font-size: 18px;
    padding: 5px;
    display: flex;
`;
